<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <Datatable :api-params="paramsComputed" :api-url="'family/getFamilySurvey'" :method-request="'POST'" :data-array-table="dataArrayTable" :router-name="'family'" :key="key" :default-sort="[{field:'_id',dir:'desc'}]" :custom-sort="[{column: 'head_name', relateColumn: ['head_surname']},{column: 'hnum', relateColumn: ['moo','village_name','soi','road','tumbol_name','amphur_name','province_name']}]" @rowClick="router.push({name: 'family-profile',params: {famid: $event._id}})" />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
import Datatable from "@/components/datatable/index.vue"
import { useRouter } from 'vue-router'
// import axios from "axios"

export default defineComponent({
  props:{
    filter:{
      type: Object
    }
  },
  components:{
    Datatable
  },
  setup(props) {
    const params = ref({start: '1',draw: '1',length: '10'})
    const key = ref(1)
    const router = useRouter()
   watch(()=>props.filter, ()=>{
      key.value++
    })
    const paramsComputed = computed(() => ({...params.value, ...props.filter}))
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.head_title ? data.head_title : ""}${data.head_name ? data.head_name: ""} ${data.head_surname ? data.head_surname : ""}`
    }
    var customAddressMutator = (value, data, type, params, component) => {
      return `${data.hnum ? data.hnum : ""} ${data.moo?'หมู่ '+data.moo:""} ${data.village_name?data.village_name: ""} ${data.soi?'ซอย '+data.soi: ""} ${data.road?'ถนน '+data.road: ""} ${data.tumbol_name?'ตำบล'+data.tumbol_name: ""}  ${data.amphur_name?'อำเภอ'+data.amphur_name: ""} ${data.province_name?'จังหวัด'+data.province_name: ""} ${data.postcode ? data.postcode : ""}`
    }
    var customProblemMutator = (value, data, type, params, component) => {
      return {"family": data.prob_family, "health": data.prob_health, "occupation": data.prob_occupation, "education": data.prob_education, "accessibility": data.prob_accessibility}
    }
    const dataArrayTable = reactive([
      {title:"หัวหน้าครอบครัว", field:"head_name",minWidth: 200, resizable:true, formatter:"textarea", mutator: customNameMutator},
      {title:"ที่อยู่", field:"hnum", hozAlign:"left",minWidth: 300, resizable:true, formatter:"textarea", mutator: customAddressMutator},
      {title:"สภาพปัญหา", field:"problem", minWidth: 220, resizable:true, mutator: customProblemMutator, variableHeight: true,
        formatter:function(cell, formatterParams){
          var value = cell.getValue();
          let res = `<div class="flex flex-wrap">\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.health > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">สุขภาพอนามัย</span>\
                        <span class="img-icon heart-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.family > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">ครอบครัว</span>\
                        <span class="img-icon home-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.occupation > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การมีงานทำและมีรายได้</span>\
                        <span class="img-icon dollar-sign-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.accessibility > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม</span>\
                        <span class="img-icon card-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.education > 0 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การศึกษา</span>\
                        <span class="img-icon book-open-icon"></span>\
                      </button>\
                      </div>`
          return res
        }
      },
      {title:"ลักษณะครอบครัว", field:"fam_type", hozAlign:"center", minWidth: 150, width: 300, resizable:true,
        formatter:function(cell, formatterParams){
          if(cell.getValue() == "ครอบครัวเดี่ยว (พ่อ แม่ ลูก)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวเดี่ยว\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวข้ามรุ่น (ปู่ ย่า ตา ยาย อยู่กับหลานตามลำพัง)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวข้ามรุ่น\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัววัยรุ่น (อายุต่ำกว่า 20 ปี)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัววัยรุ่น\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวคู่รักเพศเดียวกัน"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวคู่รักเพศเดียวกัน\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวผสม (ชายหญิงฝ่ายใดฝ่ายหนึ่งหรือทั้งสองฝ่าย มีบุตรติดมา)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวผสม\
              </button>"
          }
          else if(cell.getValue() == "อยู่คนเดียว"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              อยู่คนเดียว\
              </button>"
          }
          else{
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวขยาย\
              </button>"
          }
        }
      },
      {title:"จำนวนสมาชิก", field:"member_cnt", hozAlign:"center", resizable:true, minWidth: 150, width: 150},
    ])

    return {
      dataArrayTable,
      key,
      params,
      paramsComputed,
      router
    }
  }
})
</script>

